import { render, staticRenderFns } from "./Projetos.vue?vue&type=template&id=4037505d&lang=pug"
import script from "./Projetos.vue?vue&type=script&lang=js"
export * from "./Projetos.vue?vue&type=script&lang=js"
import style0 from "./Projetos.vue?vue&type=style&index=0&id=4037505d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports